import type { Traslado, TrasladoApi, TrasladoLinea } from '../types/traslados'

function normalizeLineas(raw: TrasladoApi): TrasladoLinea[] {
  const source = raw.detalle ?? raw.lineas ?? []
  return source.map((linea) => ({
    id: linea.id,
    sku: linea.sku,
    producto: linea.producto,
    cantidad: Number(linea.cantidad)
  }))
}

export function normalizeTraslado(raw: TrasladoApi): Traslado {
  return {
    id: raw.id,
    consecutivo: raw.consecutivo,
    estado: raw.estado,
    idempresa: raw.idempresa,
    idalmacen_origen: raw.idalmacen_origen,
    idalmacen_destino: raw.idalmacen_destino,
    codigo_almacen_origen: raw.codigo_almacen_origen,
    codigo_almacen_destino: raw.codigo_almacen_destino,
    nombre_almacen_origen: raw.nombre_almacen_origen,
    nombre_almacen_destino: raw.nombre_almacen_destino,
    id_pedido: raw.id_pedido ?? raw.idpedido ?? null,
    idorder: raw.idorder,
    flexy_idtransferencia: raw.flexy_idtransferencia,
    fecha_creacion: raw.fecha_creacion ?? raw.created_at,
    fecha_vencimiento: raw.fecha_vencimiento,
    fecha_aprobacion: raw.fecha_aprobacion,
    glosa: raw.glosa,
    usuario_creador: raw.usuario_creador,
    lineas: normalizeLineas(raw)
  }
}

export function normalizeTrasladosList(rows: TrasladoApi[] | undefined): Traslado[] {
  if (!Array.isArray(rows)) return []
  return rows.map(normalizeTraslado)
}

export function formatTrasladoFecha(fecha?: string | null): string {
  if (!fecha) return '—'
  return new Date(fecha).toLocaleString('es-CO', {
    dateStyle: 'short',
    timeStyle: 'short'
  })
}

export function getTrasladoAlmacenLabel(
  idalmacen: number,
  nombre?: string,
  codigo?: string,
  warehouses: ReadonlyArray<{ idalmacen: number; header: string; codigo: string }> = []
): string {
  if (nombre?.trim()) return nombre.trim()
  if (codigo?.trim()) return codigo.trim()
  const found = warehouses.find((warehouse) => warehouse.idalmacen === idalmacen)
  if (!found) return `Almacén ${idalmacen}`
  return `${found.header} (${found.codigo})`
}
